import React, { useMemo } from "react";
import { theme } from "theme";
import { Icons } from "..";
import { Ptag } from "../fonts";
import { Radio, Divider } from "./styles";

const SmallCard = ({ text, isSelected, onSelect }) => {
  const selectionIcon = useMemo(() => {
    // displaying different icons based on selection
    if (isSelected) {
      return "#436AB2";}
    return "#f9fcff";
  }, [isSelected]);
  return (
    <div>
      <Ptag fontWeight="600" paddingLeft="20px" fontSize="20px" marginBottom="10px" color="#4a4a4a">{text}</Ptag>
      <Divider/>
      <div style={{width: "220px", marginBottom: "3rem"}}>
        <Radio onClick={onSelect} backgroundColour={theme.accentColor} marginTop = "40px">
          <Icons style={{ 'marginRight': '8px' }} icon='upload' fill="#F9FCFF" />
          <Ptag fontWeight="600" fontSize="16px" textAlign = "center" color= "#F9FCFF">Upload Information</Ptag>
        </Radio>
      </div>
    </div>
  );
};

export default SmallCard;
